import {WeightCategory, WeightUnit} from "./enums/item-enums";

export default class ItemWeight {

    constructor() {
        this.value = 2.3;
        this.unit = WeightUnit.KG;
        this.category = WeightCategory.NORMAL;
    }
}



// WEBPACK FOOTER //
// ./src/models/item-weight.js